@for (log of activityLogs; track log) {
<div class="access-log">
  <div class="card">
    <div class="ellipse">
      <div class="chip chip-round chip-medium">
        <mat-icon [ngClass]="category(log.type)">{{category(log.type)}}</mat-icon>
      </div>
    </div>
    <div class="content">
      <div class="first-line">
        <div class="mat-body-1 title">
          {{log.typeDescription}}
        </div>
        <div class="mat-caption">
          {{log.date | date: 'MM/dd/yyyy h:mm a'}}
        </div>
      </div>
        <div class="mat-body-2">
          {{userName + ' ' + log.typeDescription + ' to ' + log.clientName}}
        </div>
    </div>
  </div>
</div>
}
